import { environment } from 'src/environments/environment';

export const ApiURL = (relativePath: string) => `${environment.apiURL}${relativePath}`;